import {useMemo} from "react";
import {map} from "lodash";
import {ICreateReturnRequest, IOrderFulfillmentItem} from "@broadleaf/admin-components/dist/types/oms";

export function useInitialValuesForCreateReturnAction(
    returnableItems: Array<IOrderFulfillmentItem>
): ICreateReturnRequest {
    return useMemo(
        () => ({
            items: map(returnableItems, item => ({
                orderFulfillmentItemId: item.id,
                quantity: 0, // Aurora Customization, start returns at 0
                primaryReturnReason: 'OTHER',
                secondaryReturnReason: 'NONE',
                expectedCondition: 'UNKNOWN',
                returnType: 'REFUND',
                note: ''
            }))
        }),
        [returnableItems]
    );
}

export default useInitialValuesForCreateReturnAction;